import { translate } from '../../../../../common/i18n';

Blockly.Blocks.max_virtual_steps = {
    init: function init() {
        this.appendDummyInput().appendField(translate('Max Virtual Steps'));
        this.setOutput(true, 'Number');
        this.setColour('#f2f2f2');
        this.setTooltip(translate('Return the max virtual steps'));
    },
    onchange: function onchange() {},
};

Blockly.JavaScript.max_virtual_steps = () => ['BinaryBotPrivateVirtualSettings.maxSteps'];



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/virtualtrades/maxsteps.js